import React, { Fragment } from "react";

import { TodaysLesson } from "../TodaysLesson";

import { LessonSummary } from "../../types";
import { TodaysLessonsProps } from "./types";

const TodaysLessons = ({ lessons }: TodaysLessonsProps) => {
  const lessonElements = lessons.map((lesson: LessonSummary, index: number) => {
    const isFinalLessonOfDay = index === lessons.length - 1;
    const nextLesson = !isFinalLessonOfDay ? lessons[index + 1] : null;

    return (
      <Fragment key={`lesson-${index}`}>
        <TodaysLesson lesson={lesson} nextLesson={nextLesson} />
      </Fragment>
    );
  });

  return <Fragment>{lessonElements}</Fragment>;
};

export default TodaysLessons;
